import { useEffect, useRef, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useRenderedSlides } from "@/hooks/useRenderedSlides";

export default function HeroDatacenter({ onOpenQuote }: { onOpenQuote?: (service?: string) => void }) {
  const { t } = useTranslation("common");
  const [current, setCurrent] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const renderedSlides = useRenderedSlides(current);

  const slides = useMemo(() => [
    {
      id: "dc-hero-1",
      tag: t("dc.hero.slide1.tag"),
      title: t("dc.hero.slide1.title"),
      titleHighlight: t("dc.hero.slide1.highlight"),
      subtitle: t("dc.hero.slide1.subtitle"),
      cta: t("dc.hero.slide1.cta"),
      ctaLink: "#features",
      image:
        "https://readdy.ai/api/search-image?query=Modern%20enterprise%20data%20center%20interior%20with%20rows%20of%20illuminated%20server%20racks%2C%20blue%20LED%20ambient%20lighting%2C%20raised%20floor%20with%20clean%20cable%20management%2C%20professional%20technology%20photography%2C%20dark%20sophisticated%20atmosphere%20with%20cyan%20accent%20lights%2C%20high%20availability%20infrastructure%2C%20corporate%20security%20aesthetic%2C%20wide%20angle%20view&width=1600&height=800&seq=dc-hero-1&orientation=landscape",
      imageSrcSet:
        "https://readdy.ai/api/search-image?query=Modern%20enterprise%20data%20center%20interior%20with%20rows%20of%20illuminated%20server%20racks%2C%20blue%20LED%20ambient%20lighting%2C%20raised%20floor%20with%20clean%20cable%20management%2C%20professional%20technology%20photography%2C%20dark%20sophisticated%20atmosphere%20with%20cyan%20accent%20lights%2C%20high%20availability%20infrastructure%2C%20corporate%20security%20aesthetic%2C%20wide%20angle%20view&width=1280&height=640&seq=dc-hero-1&orientation=landscape 1280w, https://readdy.ai/api/search-image?query=Modern%20enterprise%20data%20center%20interior%20with%20rows%20of%20illuminated%20server%20racks%2C%20blue%20LED%20ambient%20lighting%2C%20raised%20floor%20with%20clean%20cable%20management%2C%20professional%20technology%20photography%2C%20dark%20sophisticated%20atmosphere%20with%20cyan%20accent%20lights%2C%20high%20availability%20infrastructure%2C%20corporate%20security%20aesthetic%2C%20wide%20angle%20view&width=1600&height=800&seq=dc-hero-1&orientation=landscape 1600w",
    },
    {
      id: "dc-hero-2",
      tag: t("dc.hero.slide2.tag"),
      title: t("dc.hero.slide2.title"),
      titleHighlight: t("dc.hero.slide2.highlight"),
      subtitle: t("dc.hero.slide2.subtitle"),
      cta: t("dc.hero.slide2.cta"),
      ctaLink: "#features",
      image:
        "https://readdy.ai/api/search-image?query=Data%20center%20power%20infrastructure%20room%20with%20redundant%20UPS%20systems%20and%20backup%20generators%2C%20blue%20ambient%20lighting%2C%20industrial%20clean%20aesthetic%2C%20professional%20technology%20photography%2C%20dark%20sophisticated%20atmosphere%2C%20enterprise%20reliability%20concept%2C%20navy%20and%20steel%20blue%20color%20palette&width=1600&height=800&seq=dc-hero-2&orientation=landscape",
      imageSrcSet:
        "https://readdy.ai/api/search-image?query=Data%20center%20power%20infrastructure%20room%20with%20redundant%20UPS%20systems%20and%20backup%20generators%2C%20blue%20ambient%20lighting%2C%20industrial%20clean%20aesthetic%2C%20professional%20technology%20photography%2C%20dark%20sophisticated%20atmosphere%2C%20enterprise%20reliability%20concept%2C%20navy%20and%20steel%20blue%20color%20palette&width=1280&height=640&seq=dc-hero-2&orientation=landscape 1280w, https://readdy.ai/api/search-image?query=Data%20center%20power%20infrastructure%20room%20with%20redundant%20UPS%20systems%20and%20backup%20generators%2C%20blue%20ambient%20lighting%2C%20industrial%20clean%20aesthetic%2C%20professional%20technology%20photography%2C%20dark%20sophisticated%20atmosphere%2C%20enterprise%20reliability%20concept%2C%20navy%20and%20steel%20blue%20color%20palette&width=1600&height=800&seq=dc-hero-2&orientation=landscape 1600w",
    },
    {
      id: "dc-hero-3",
      tag: t("dc.hero.slide3.tag"),
      title: t("dc.hero.slide3.title"),
      titleHighlight: t("dc.hero.slide3.highlight"),
      subtitle: t("dc.hero.slide3.subtitle"),
      cta: t("dc.hero.slide3.cta"),
      ctaLink: "#features",
      image:
        "https://readdy.ai/api/search-image?query=Secure%20data%20center%20entrance%20with%20biometric%20access%20control%20systems%20and%20security%20monitoring%20stations%2C%20blue%20ambient%20lighting%2C%20professional%20corporate%20security%20environment%2C%20dark%20sophisticated%20atmosphere%2C%20modern%20access%20control%20technology%2C%20navy%20and%20cyan%20tones%2C%20high%20detail%20photography&width=1600&height=800&seq=dc-hero-3&orientation=landscape",
      imageSrcSet:
        "https://readdy.ai/api/search-image?query=Secure%20data%20center%20entrance%20with%20biometric%20access%20control%20systems%20and%20security%20monitoring%20stations%2C%20blue%20ambient%20lighting%2C%20professional%20corporate%20security%20environment%2C%20dark%20sophisticated%20atmosphere%2C%20modern%20access%20control%20technology%2C%20navy%20and%20cyan%20tones%2C%20high%20detail%20photography&width=1280&height=640&seq=dc-hero-3&orientation=landscape 1280w, https://readdy.ai/api/search-image?query=Secure%20data%20center%20entrance%20with%20biometric%20access%20control%20systems%20and%20security%20monitoring%20stations%2C%20blue%20ambient%20lighting%2C%20professional%20corporate%20security%20environment%2C%20dark%20sophisticated%20atmosphere%2C%20modern%20access%20control%20technology%2C%20navy%20and%20cyan%20tones%2C%20high%20detail%20photography&width=1600&height=800&seq=dc-hero-3&orientation=landscape 1600w",
    },
  ], [t]);

  const goTo = (idx: number) => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setTimeout(() => {
      setCurrent(((idx % slides.length) + slides.length) % slides.length);
      setIsTransitioning(false);
    }, 400);
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      goTo((current + 1) % slides.length);
    }, 7000);
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, [current]);

  const slide = slides[current];

  return (
    <section id="hero-dc" className="relative w-full h-[580px] md:h-[660px] overflow-hidden">
      {slides.map((s, idx) =>
        renderedSlides.includes(idx) ? (
          <div
            key={s.id}
            className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${idx === current ? "opacity-100" : "opacity-0"}`}
          >
            <img src={s.image} alt={s.title + " " + s.titleHighlight} width={1600} height={800} srcSet={s.imageSrcSet} sizes="100vw" loading={idx === current ? "eager" : "lazy"} fetchPriority={idx === current ? "high" : "low"} className="w-full h-full object-cover object-top" decoding="async" />
            <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/45" />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-transparent to-black/55" />
            <div className="absolute inset-0 bg-black/45 md:hidden" />
          </div>
        ) : null,
      )}

      {/* Bottom transition into the next section */}
      <div className="absolute bottom-0 left-0 right-0 h-24 md:h-32 bg-gradient-to-b from-transparent to-background-950 pointer-events-none" />

      <div
        className="absolute inset-0 pointer-events-none opacity-[0.03]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(34,211,238,0.5) 1px, transparent 1px), linear-gradient(90deg, rgba(34,211,238,0.5) 1px, transparent 1px)",
          backgroundSize: "60px 60px",
        }}
      />

      <div className="absolute inset-0 flex items-center z-20">
        <div className="w-full px-5 sm:px-10 lg:px-16 pt-16 sm:pt-20">
          <div className={`max-w-2xl transition-all duration-700 ${isTransitioning ? "opacity-0 translate-y-4" : "opacity-100 translate-y-0"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-primary-400/30 bg-primary-500/10 mb-5">
              <span className="w-1.5 h-1.5 rounded-full bg-primary-400 animate-pulse" />
              <span className="text-[10px] font-label font-semibold text-primary-300 uppercase tracking-[0.2em]">
                {slide.tag}
              </span>
            </div>

            <h1 className="font-heading font-bold text-[26px] sm:text-4xl md:text-5xl lg:text-6xl text-white leading-[1.15] mb-4">
              {slide.title}{" "}
              <span className="bg-gradient-to-r from-primary-300 via-primary-400 to-cyan-400 bg-clip-text text-transparent">
                {slide.titleHighlight}
              </span>
            </h1>

            <p className="text-sm md:text-base text-white/70 leading-relaxed mb-8 max-w-xl">
              {slide.subtitle}
            </p>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href={slide.ctaLink}
                onClick={(e) => {
                  e.preventDefault();
                  const el = document.querySelector(slide.ctaLink);
                  if (el) el.scrollIntoView({ behavior: "smooth" });
                }}
                className="group inline-flex w-full sm:w-auto items-center justify-between sm:justify-start gap-4 pl-6 pr-2 py-2 rounded-full border border-primary-400/50 bg-primary-500/15 backdrop-blur-md text-white font-label font-medium text-sm md:text-base hover:border-primary-400/80 hover:bg-primary-500/25 transition-all duration-500 whitespace-nowrap cursor-pointer"
              >
                <span>{t("shared.ctaPrimary")}</span>
                <span className="flex items-center justify-center w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-500 text-white group-hover:bg-primary-400 transition-colors duration-300">
                  <i className="ri-arrow-right-line text-base md:text-lg group-hover:translate-x-0.5 transition-transform duration-300" />
                </span>
              </a>
              <button
                type="button"
                onClick={() => onOpenQuote?.("Datacenter e Infraestructura")}
                className="group inline-flex w-full sm:w-auto items-center justify-between sm:justify-start gap-4 pl-6 pr-2 py-2 rounded-full border border-white/15 bg-white/5 backdrop-blur-md text-foreground-100 font-label font-medium text-sm md:text-base hover:border-primary-400/40 hover:bg-white/10 transition-all duration-500 whitespace-nowrap cursor-pointer"
              >
                <span>{t("shared.ctaSecondary")}</span>
                <span className="flex items-center justify-center w-9 h-9 md:w-10 md:h-10 rounded-full border border-primary-400/40 text-primary-300 group-hover:bg-primary-500 group-hover:text-white group-hover:border-primary-500 transition-all duration-300">
                  <i className="ri-chat-smile-3-line text-base md:text-lg" />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-20 flex items-center gap-2">
        {slides.map((_, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => goTo(idx)}
            className={`rounded-full transition-all duration-500 cursor-pointer ${idx === current ? "w-8 h-2 bg-primary-400" : "w-2 h-2 bg-white/30 hover:bg-white/60"}`}
            aria-label={`Slide ${idx + 1}`}
          />
        ))}
      </div>

      <div className="absolute top-20 right-6 md:top-24 md:right-8 z-20">
        <div className="inline-flex items-center gap-2 px-3 py-2 rounded-xl bg-background-950/80 backdrop-blur-md border border-primary-400/20">
          <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
          <span className="text-[10px] font-label font-semibold text-foreground-200/80 uppercase tracking-[0.15em]">
            {t("dc.header.active")}
          </span>
        </div>
      </div>
    </section>
  );
}